module.exports = __webpack_public_path__ + "img/spring-air-aviation.a0cd8693.jpg";